import { render, staticRenderFns } from "./PdfJsViewer.vue?vue&type=template&id=86df9c82&"
import script from "./PdfJsViewer.vue?vue&type=script&lang=js&"
export * from "./PdfJsViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports